<template>
    <div>
        <div
            v-show="selected.includes(option.name)"
            :id="'divSubMenu_' + option.name"
            :class="`submenu-level-${level}`"
        >
            <ul class="ProductList">
                <MenuIcon
                    v-for="item in option.products"
                    :key="item.name"
                    :option="item"
                    :selected="selected"
                    @click="(val) => $emit('click', val)"
                />
            </ul>
        </div>
        <div v-if="selected.includes(option.name) && level === 1 && selected.length > 1" class="submenu-arrow"></div>
        <template v-for="item in option.products">
            <IconMenu
                v-if="item.products"
                :key="item.name"
                :level="level + 1"
                :option="item"
                :selected="selected"
                @click="(val) => $emit('click', val)"
            />
        </template>
    </div>
</template>

<script>
    import MenuIcon from './MenuIcon';

    export default {
        name: 'IconMenu',
        components: {
            MenuIcon,
        },
        props: {
            level: {
                type: Number,
                default: 1,
            },
            option: {
                type: Object,
                required: true,
            },
            selected: {
                type: Array,
                required: true,
            },
        },
        emits: ['click'],
    };
</script>
